import Request from './core/Request'

export default Request
